module.exports = __webpack_public_path__ + "img/tasks.24ef4518.svg";